<template>
  <PageContainer class="container">
    <template v-slot:body>
      <HeadingSmall class="header">
        Shared Folder Settings
      </HeadingSmall>
      <div class="content">
        <SharedFoldersSettingsCard />
      </div>
    </template>
    <template v-slot:footer>
      <Container class="footer">
        <ButtonGroupSave
          :isFullWidth="false"
          :primaryButtonProps="primaryButtonProps"
          :secondaryButtonProps="secondaryButtonProps"
        />
      </Container>
    </template>
  </PageContainer>
</template>

<script>
import {
  ButtonGroupSave,
  Container,
  HeadingSmall,
  PageContainer,
  Types,
} from '@jumpcloud/ui-components';
import SharedFoldersSettingsCard from 'client/PasswordManager/SharedFoldersSettings/SharedFoldersSettingsCard.vue';

const { PrimaryButtonProps, SecondaryButtonProps } = Types;

export default {
  name: 'PwmSharedFoldersSettings',

  components: {
    ButtonGroupSave,
    Container,
    HeadingSmall,
    PageContainer,
    SharedFoldersSettingsCard,
  },

  computed: {
    primaryButtonProps() {
      return PrimaryButtonProps({
        text: 'save',
      });
    },

    secondaryButtonProps() {
      return SecondaryButtonProps({
        text: 'cancel',
        type: 'secondary',
      });
    },
  },
};
</script>

  <style scoped>
    .container {
      background-color: var(--jcWhite);
      height: 100%;
      overflow: hidden;
    }

    .header {
      background-color: var(--jcWhite50);
      padding: var(--jcHeadingSmall);
    }

    .content {
      display: flex;
      padding-left: var(--jc-spacer);
    }

    .footer {
      background-color: var(--jcWhite50);
    }
  </style>
